import { useState } from 'react';
import { Tab, TabGroup } from '@humanforce/mango-ui-react';
import { LeaveConfigurationScreen } from '../features/leaveRules/LeaveConfigurationScreen';
import { LeaveRulesScreen } from '../features/leaveRules/LeaveRulesScreen';

export const LeavePage = () => {
  const [tab, setTab] = useState('rules');
  return <><TabGroup value={tab} onValueChange={setTab}><Tab value="rules" label="Leave rules" /><Tab value="framework" label="LSL and leave configuration" /></TabGroup>{tab === 'rules' ? <LeaveRulesScreen /> : <LeaveConfigurationScreen />}</>;
};
